import React, { useState } from "react";
import "./speech.css";
import { Button } from "reactstrap";
import { createProduct } from "../../helpers/urlConfig/apiFunctions";
import { getSessionData } from "../../helpers/sessionDetailsParser";
import {
  errorToastify,
  successToastify,
} from "../../Components/Common/Toaster";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SpeechRecognition = () => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  let recognition;

  if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    recognition = new SpeechRecognition();

    recognition.continuous = true;
    recognition.interimResults = true;
    recognition.lang = "en-US";
  } else {
    console.error("Speech Recognition not supported in this browser.");
  }

  const startListening = () => {
    if (recognition) {
      recognition.start();
      setIsListening(true);

      recognition.onresult = (event) => {
        let interimTranscript = "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcriptSegment = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            const newTranscript = transcript + transcriptSegment;
            setTranscript(newTranscript);

            // Automatically handle navigation
            if (newTranscript.includes("move")) {
              const navigatePage = newTranscript.split(" ")[1];
              switch (navigatePage) {
                case "product":
                  navigate("/product-list");
                  setTranscript("");
                  break;
                case "customer":
                  navigate("/customer-list");
                  setTranscript("");
                  break;
                case "user":
                  navigate("/user-list");
                  setTranscript("");
                  break;
                case "product type":
                  navigate("/productType-list");
                  setTranscript("");
                  break;
                case "order":
                  navigate("/order-list");
                  setTranscript("");
                  break;
                default:
                  errorToastify("Invalid Page Names");
              }
            }

            if (newTranscript.includes("get order")) {
              const orderID = newTranscript.split("order")[1];
              const processedNumber = parseInt(orderID.trim());
              if (processedNumber == NaN || processedNumber == undefined) {
                errorToastify("Invalid Order Number");
                return;
              }
              navigate(`/order-product/${processedNumber}`);
            }
          } else {
            interimTranscript += transcriptSegment;
          }
        }
      };

      recognition.onerror = (event) => {
        setError(event.error);
        console.error("Speech recognition error:", event.error);
      };
    }
  };

  const stopListening = () => {
    if (recognition) {
      recognition.stop();
      setIsListening(false);
    }
  };

  const handleSubmitBtn = async () => {
    if (transcript.length === 0) {
      errorToastify("Please say something");
      return;
    }
    if (transcript) {
      if (transcript.includes("product")) {
        const body = {
          product_name: transcript.split(" ")[1],
          created_by: getSessionData("user_id"),
        };
        const response = await createProduct(body);
        response.statusCode === 200
          ? successToastify("Product created successfully")
          : errorToastify("Error Creating Product");
      }
    }
  };

  return (
    <div className="page-content">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="speech-container">
          <div className="speech-card">
            <h2>🎙 Speech Recognition</h2>
            <p className="instructions">
              Click "Start Listening" and say something.
            </p>
            <button
              onClick={isListening ? stopListening : startListening}
              className={`speech-button ${isListening ? "listening" : ""}`}
            >
              {isListening ? "🔴 Stop Listening" : "🎤 Start Listening"}
            </button>
            <div className="transcript-box">
              <h4>Transcript:</h4>
              <p className="transcript">{transcript || "Say something..."}</p>
            </div>
            <Button
              color="success"
              onClick={handleSubmitBtn}
              className="submit-btn"
            >
              Submit
            </Button>
            {error && <p className="error-text">Error: {error}</p>}
          </div>
        </div>
      </div>
      <h5 style={{ color: "red" }}>Notes:</h5>
      <span className="badge badge-label bg-primary">
        <i className="mdi mdi-circle-medium"></i> For Creating New Products
      </span>
      <p>Example: "product product-name"</p>

      <span className="badge badge-label bg-primary">
        <i className="mdi mdi-circle-medium"></i> For Navigate To Pages
      </span>
      <p>Example: "move page-name"</p>

      <span className="badge badge-label bg-primary">
        <i className="mdi mdi-circle-medium"></i> For Get Orders By ID
      </span>
      <p>Example: "get order order-number"</p>
      <ToastContainer />
    </div>
  );
};

export default SpeechRecognition;
